const BASE = import.meta.env.VITE_API_BASE;

export async function apiFetch(path: string, token: string, init: RequestInit = {}) {
  const r = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      ...(init.headers || {}),
      authorization: `Bearer ${token}`,
      "content-type": init.body ? "application/json" : "application/json",
    },
  });
  if (!r.ok) throw new Error(`${r.status} ${await r.text()}`);
  return r.json();
}

export async function presignUpload(token: string, contentType: string) {
  return apiFetch("/uploads/presign", token, {
    method: "POST",
    body: JSON.stringify({ content_type: contentType }),
  });
}

export async function uploadToS3(post: any, file: File) {
  const fd = new FormData();
  for (const [k, v] of Object.entries(post.fields)) fd.append(k, v as string);
  fd.append("file", file);
  const r = await fetch(post.url, { method: "POST", body: fd });
  if (!r.ok) throw new Error(`s3 upload failed: ${r.status}`);
}

export async function createJob(token: string, image_key: string, prompt: string) {
  return apiFetch("/jobs", token, {
    method: "POST",
    body: JSON.stringify({ image_key, prompt }),
  });
}

export async function listJobs(token: string) {
  return apiFetch("/jobs", token);
}

export async function getMe(token: string) {
  return apiFetch("/me", token);
}

export async function acceptTerms(token: string) {
  return apiFetch("/me/accept-terms", token, { method: "POST" });
}

export async function getPacks(token: string) {
  return apiFetch("/packs", token);
}

export async function startCheckout(token: string, pack_id: string) {
  return apiFetch("/checkout", token, {
    method: "POST",
    body: JSON.stringify({ pack_id }),
  });
}

export async function unlockJob(token: string, id: string) {
  return apiFetch(`/jobs/${id}/unlock`, token, { method: "POST" });
}

export async function regenerateJob(token: string, id: string, prompt?: string) {
  return apiFetch(`/jobs/${id}/regenerate`, token, {
    method: "POST",
    body: JSON.stringify(prompt ? { prompt } : {}),
  });
}

// ----- admin -----
export async function adminListUsers(token: string, q?: string) {
  const qs = q ? `?q=${encodeURIComponent(q)}` : "";
  return apiFetch(`/admin/users${qs}`, token);
}
export async function adminGrant(
  token: string, sub: string, body: { delta_credits?: number; delta_tokens?: number; reason?: string },
) {
  return apiFetch(`/admin/users/${sub}/grant`, token, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
export async function adminListJobs(token: string, opts: { status?: string; user?: string } = {}) {
  const p = new URLSearchParams();
  if (opts.status) p.set("status_eq", opts.status);
  if (opts.user) p.set("user", opts.user);
  const qs = p.toString() ? `?${p}` : "";
  return apiFetch(`/admin/jobs${qs}`, token);
}
export async function adminRefundJob(token: string, id: string) {
  return apiFetch(`/admin/jobs/${id}/refund`, token, { method: "POST" });
}
export async function adminListComplaints(token: string) {
  return apiFetch(`/admin/complaints`, token);
}
export async function adminUserLedger(token: string, sub: string) {
  return apiFetch(`/admin/users/${sub}/ledger`, token);
}
